import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

// Open the date picker calendar on any click within a date input, not just on the icon
document.addEventListener("click", (e) => {
  const target = e.target as HTMLElement;
  if (target instanceof HTMLInputElement && target.type === "date" && !target.disabled) {
    try { target.showPicker(); } catch { /* unsupported browser */ }
  }
});

// Stop the mouse wheel from silently changing a focused number input's value
// while the user is just scrolling the page.
document.addEventListener("wheel", () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === "number") el.blur();
}, { passive: true });

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
